import { Component, OnInit } from '@angular/core';
import { UserDetailComponent } from '../user/user-detail/user-detail.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { MainPage } from '../../app/model/main-page.model';

@Component({
  providers: [UserDetailComponent],
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {

  resultTable: MainPage[] = null;
  //resultModel = new MainPage (null,null,null,null,null);
  resultModel: MainPage = null
  userDetails: any = null;
  cols: any[];
  msgs: any[] = [];
  dataResults: MainPage[] = null;
  //dataResults: any[] = [{}];
  currentDate: Date = new Date();
  current: Date = new Date();
  date1: Date = new Date();
  date2: Date = new Date();
  date3: Date = new Date();

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.date1 = new Date(this.date1.getFullYear(), this.current.getMonth() - 1, this.date1.getDate())
    this.date2 = new Date(this.date2.getFullYear(), this.current.getMonth() - 2, this.date2.getDate())
    this.date3 = new Date(this.date3.getFullYear(), this.current.getMonth() - 3, this.date3.getDate())
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration) {
        
      }
      else {
        
      }
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
        this.showMessage('error', '', 'שגיאה בקבלת הרשאות');
      });

    
  }

  

  getMonthName(m): any {
    let mont = '';
    switch (m.getMonth() + 1) {
      case 1:
        mont = 'ינואר';
        break;
      case 2:
        mont = 'פברואר';
        break;
      case 3:
        mont = 'מרץ';
        break;
      case 4:
        mont = 'אפריל';
        break;
      case 5:
        mont = 'מאי';
        break;
      case 6:
        mont = 'יוני';
        break;
      case 7:
        mont = 'יולי';
        break;
      case 8:
        mont = 'אוגוסט';
        break;
      case 9:
        mont = 'ספטמבר';
        break;
      case 10:
        mont = 'אוקטובר';
        break;
      case 11:
        mont = 'נובמבר';
        break;
      case 12:
        mont = 'דצמבר';
        break;
     
    }   
    return mont;
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/main-page/main-page.component.ts